import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Button } from "react-bootstrap";

const HenkinHintikkaGameButton = ({
  onClick,
  gameEnabled,
  disabled
}) => /*#__PURE__*/React.createElement(Button, {
  size: "sm",
  onClick: () => onClick(),
  variant: "outline-secondary",
  active: gameEnabled,
  disabled: disabled,
  title: `${gameEnabled ? 'End' : 'Start'} Henkin-Hintikka game`
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-gamepad"
}));

export default HenkinHintikkaGameButton;